import { createApi } from "@reduxjs/toolkit/query/react";
import axiosBaseQuery from "../axiosBaseQuery";

const notificationApi = createApi({
  reducerPath: "base/notification",
  baseQuery: axiosBaseQuery,
  tagTypes: ["notificationList"],
  endpoints: (builder) => ({
    notificationFindAll: builder.query<{ data: any[]; pagination: any }, string | void>({
      providesTags: ["notificationList"],
      query: (query = "") => ({
        url: "/base/notifications/user/me" + query,
        method: "GET",
      }),
      transformResponse: (response: any) => ({
        data: response.data,
        pagination: response.pagination,
      }),
    }),

    notificationUnreadCount: builder.query<{ unread_count: number }, void>({
      query: () => ({
        url: "/base/notifications/user/unread-count",
        method: "GET",
      }),
    }),

    notificationMarkRead: builder.mutation({
      invalidatesTags: ["notificationList"],
      query: (id) => ({
        url: `/base/notifications/${id}/read`,
        method: "POST",
      }),
    }),

    notificationCreate: builder.mutation({
      invalidatesTags: ["notificationList"],
      query: (data) => ({
        url: "/base/notifications",
        method: "POST",
        data,
      }),
    }),

    notificationDelete: builder.mutation({
      invalidatesTags: ["notificationList"],
      query: (id) => ({
        url: `/base/notifications/${id}`,
        method: "DELETE",
      }),
    }),
  }),
});

export const {
  useNotificationFindAllQuery,
  useNotificationMarkReadMutation,
  useNotificationCreateMutation,
  useNotificationDeleteMutation,
  useNotificationUnreadCountQuery,
} = notificationApi;

export { notificationApi };